<script>
export default {
  computed: {
    optionsArray () {
      if (!Array.isArray(this.options)) {
        return Object.keys(this.options).reduce((acc, key) => {
          acc.push({
            value: key,
            label: this.options[key]
          })
          return acc
        }, [])
      }

      if (!this.options.length) {
        return []
      }

      if (typeof this.options[0] === 'object') {
        return this.options
      }

      return this.options.map((option, index) => {
        let label;

        if (option.title) {
          label = option.title
        } else if (option.name) {
          label = option.name
        } else {
          label = `${option} ${index}`
        }

        return {
          value: option.id,
          label: label
        }
      })
    },
  }
}
</script>
